<div class="suggested-questions-container">
    @for (question of questions; track question) {
        <div class="question" (click)="sendQuestionToInputBar(question)"><img class="chatbox-icon" src="svg/chats.svg">{{ question }}</div>
    }
    <div class="question refresh-questions" (click)="refreshQuestions()"
         matTooltip="Refresh questions" matTooltipPosition="above" matTooltipClass="tooltip-with-triangle">
         <img class="refresh-icon" [src]="'svg/circling-arrows.svg' | assetVersion" alt="refresh">
    </div>
</div>
